export enum Section {
  HOME = 'home',
  ABOUT = 'about',
  SERVICES = 'services',
  PRODUCTS = 'products',
  CONTACT = 'contact'
}

export interface Project {
  id: string;
  title: string;
  description: string;
  status: 'Live' | 'In Development' | 'Concept' | 'Beta';
  category: 'EdTech' | 'FinTech' | 'Game';
  image: string;
  features: string[];
}

export interface ChatMessage {
  role: 'user' | 'model';
  text: string;
  timestamp: number;
}
